import { z } from 'zod';
import { MIN_NAME_LENGTH } from '../../domain/constants';

export const profileUpdateFormSchema = z.object({
  name: z.string().min(MIN_NAME_LENGTH, 'Name must be at least 2 characters'),
  dob: z.string(),
  birthTime: z.string(),
  birthPlace: z.string(),
});

export type ProfileUpdateFormData = z.infer<typeof profileUpdateFormSchema>;
